import React from 'react';

class ExpandableFloatingDropdownItem extends React.Component {
    render() {
        return (
            <div className="expandable-floating-dropdown-item" onClick={this.props.onClick}>
                {this.props.children}
            </div>
        )
    }
}

class ExpandableFloatingDropdownDivider extends React.Component {
    render() {
        return (
            <div className="expandable-floating-dropdown-divider"></div>
        )
    }
}

export default class ExpandableFloatingDropdown extends React.Component {

    static Item = ExpandableFloatingDropdownItem;
    static Divider = ExpandableFloatingDropdownDivider;

    constructor(props) {
        super(props);

        this.state = {
            open: false
        }
    }

    onRootClick = e => {
        this.setState({
            open: !this.state.open
        });
    }

    close = () => {
        this.setState({
            open: false
        });
    }

    render() {
        const children = Array.isArray(this.props.children) ? this.props.children.filter(x => x) : [this.props.children];

        return (
            <div className={`expandable-floating-dropdown ${this.state.open ? 'open' : ''}`}>
                <div className="expandable-floating-dropdown-trigger" onClick={this.onRootClick}>
                    <svg width="100%" height="100%" className="expandable-floating-dropdown-trigger-1">
                        <g>
                            <circle cx="24" cy="17" r="2" fill="#ffffff"></circle>
                            <circle cx="24" cy="24" r="2" fill="#ffffff"></circle>
                            <circle cx="24" cy="31" r="2" fill="#ffffff"></circle>
                        </g>
                    </svg>

                    <svg width="100%" height="100%" viewBox="0 0 22.87 22.87"
                         className="expandable-floating-dropdown-trigger-2">
                        <g>
                            <path fill="#ffffff" d="M0.324,1.909c-0.429-0.429-0.429-1.143,0-1.587c0.444-0.429,1.143-0.429,1.587,0l9.523,9.539
        l9.539-9.539c0.429-0.429,1.143-0.429,1.571,0c0.444,0.444,0.444,1.159,0,1.587l-9.523,9.524l9.523,9.539
        c0.444,0.429,0.444,1.143,0,1.587c-0.429,0.429-1.143,0.429-1.571,0l-9.539-9.539l-9.523,9.539c-0.444,0.429-1.143,0.429-1.587,0
        c-0.429-0.444-0.429-1.159,0-1.587l9.523-9.539L0.324,1.909z"/>
                        </g>
                    </svg>
                </div>

                <div className="expandable-floating-dropdown-body">
                    {children.map((child, idx) => (
                        <div key={idx} style={{transitionDelay: (children.length - idx - 1) * 25 + 50 + 'ms'}}>
                            {child}
                        </div>
                    ))}
                </div>
            </div>
        )
    }
}
